export const XANO_API_BASE_URL = `${process.env.REACT_APP_XANO_API_BASE_URL}`;
